import { Component, OnInit, Input, OnDestroy, SecurityContext } from '@angular/core';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-view-assessment-report',
  templateUrl: './view-assessment-report.component.html',
  styleUrls: ['./view-assessment-report.component.css']
})
export class ViewAssessmentReportComponent implements OnInit, OnDestroy {

  @Input() jobMatchId;
  @Input() testInvitationId;
  @Input() assessmentType;
  @Input() isSectionalReport;
  @Input() context;

  availabilityDate: any;
  availabilityObject: any = {};
  jobMatch: any = {};
  companyId: any;
  url: SafeResourceUrl;
  embedUrl: SafeResourceUrl;
  reportTitle: any;
  reportGenerating: boolean = false;
  _pdfBlobUrl: string;

  loadingFlag: boolean = false;
  reportLoadingFlag: boolean = true;
  isStaffingCompany: boolean;


  constructor(
    private authService: AuthService,
    private companyService: CompanyService,
    private jobMatchService: JobMatchService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private sanitizer: DomSanitizer
  ) {
    // initialize to a safe resource URL so Angular's RESOURCE_URL sanitizer
    // doesn't throw when template binds before the endpoint response arrives
    this.embedUrl = this.getSafeUrl('about:blank');
    this.url = this.getSafeUrl('about:blank');
  }

  ngOnInit() {
    this.companyId = this.authService.getUserDetails().company.companyId;
    this.reportTitle = this.assessmentType == 'Technical' ? 'Technical Assessment Report' : 'Value Assessment Report';

    //flags
    this.loadingFlag = true;
    this.reportLoadingFlag = true;
    this.isStaffingCompany = this.companyService.isStaffingCompany();

    this._getJobMatchCardInfo();
  }
  
  _getJobMatchCardInfo() {
    this.loadingFlag = true;
    this.reportLoadingFlag = true;
    this.jobMatchService.getCandidateJobMatchCard(this.jobMatchId, this.companyId, (data) => {
      this.jobMatch = data;
      this.jobMatch.name = this.jobMatch.firstName + ' ' + this.jobMatch.lastName;
      this._getReport();
      this.loadingFlag = false;
      setTimeout(() => {
        this.reportLoadingFlag = false;
      }, 3000);
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    }, undefined);

  }

  _getReport() {
    if (this.isSectionalReport == undefined && this.context == "notification") {
      this.isSectionalReport = this.isStaffingCompany && this.jobMatch.isSharedRequisition;
    }

    const endpoint = 'api/candidate/candidatepdfreport?testinvitationid=' + this.testInvitationId + '&sectional=' + this.isSectionalReport;

    this.reportLoadingFlag = true;
    this.reportGenerating = false;

    fetch(endpoint, { method: 'GET' }).then((response) => {
      if (!response.ok) {
        // ensure template bindings use a SafeResourceUrl to avoid sanitizer errors
        this.embedUrl = this.getSafeUrl('about:blank');
        this.url = this.getSafeUrl('about:blank');
        this.reportGenerating = true;
        this.reportLoadingFlag = false;
        return;
      }

      const contentType = response.headers.get('content-type') || '';

      if (contentType.indexOf('application/pdf') !== -1) {
        this.embedUrl = this.getSafeUrl(endpoint + '#view=fitH');
        this.url = this.getSafeUrl(endpoint);
        this.reportLoadingFlag = false;
        return;
      }

      // If server returns JSON or no PDF, treat as "generating" state
      return response.text().then(text => {
        let hasData = false;
        try {
          const json = text && text.length ? JSON.parse(text) : null;
          if (json && (json.filepath || json.fileName || json.data)) {
            hasData = true;
          }
        } catch (e) {
          // not json
        }

        if (hasData) {
          this.embedUrl = this.getSafeUrl(endpoint + '#view=fitH');
          this.url = this.getSafeUrl(endpoint);
          this.reportLoadingFlag = false;
        } else {
          this.reportGenerating = true;
          this.reportLoadingFlag = false;
        }
      });
    }).catch((err) => {
      this.alertsAndNotificationsService.showBannerMessage(err.message || 'Error fetching report', 'danger');
      this.reportLoadingFlag = false;
    });
  }

  ngOnDestroy() {
    if (this._pdfBlobUrl) {
      URL.revokeObjectURL(this._pdfBlobUrl);
    }
  }

  getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
